import React, { useRef } from "react";
import PropTypes from "prop-types";
import { UncontrolledTooltip } from "reactstrap";

const WithTooltip = ({ tooltipText, children }) => {
  const tooltipRef = useRef(null);
  return (
    <>
      <span ref={tooltipRef}>
        {children}
      </span>
      <UncontrolledTooltip target={tooltipRef}>{tooltipText}</UncontrolledTooltip>
    </>
  );
};

WithTooltip.propTypes = {/** text for tooltip */
  tooltipText: PropTypes.string,
  /** node that will be target of tooltip */
  children: PropTypes.node
};

export default WithTooltip;
